import API_MAP from "../../util/API_MAP";
import API_MANAGER from "../../util/API_MANAGER";

const state = {
	hasData: false, // 是否请求了协议数据
	protocolObj: {}, // 协议信息对象
	VISA_URL: '' // VISA 协议下载地址
};

const getters = {
	protocolUrl: state => {
		let result = {
			zh_url: '',
			en_url: ''
		};
		const protocolObj = state.protocolObj;
		if (!protocolObj.documents) {
			return result;
		}
		if (!Array.isArray(protocolObj.documents)) {
			return result;
		}
		protocolObj.documents.map(item => {
			if (item.type === 5) {
				result.zh_url = item.url;
			}
			if (item.type === 6) {
				result.en_url = item.url;
			}
		});
		return result;
	}
};

const actions = {
	// 获取协议信息
	getProtocol({commit}, callback) {
		let api = API_MAP.PROTOCOL_INFO;
		let method = 'get';
		let successCb = (data) => {
			commit('setHasData', true);
			commit('setProtocol', data);
			callback();
		};
		let errorCb = () => {

		};
		// 静默失败，不弹出错误提示
		API_MANAGER({api, method, successCb, errorCb, commit, silentError: true});
	},
	// 同意协议
	agreeProtocol({commit, state, rootState}) {
		let api = API_MAP.USER_BASIC;
		let method = 'json';
		let payload = {
			is_agree_protocol: true,
			user_id: rootState.main.currentUser['user_id']
		};
		let successCb = () => {
		};
		let errorCb = () => {
		};
		API_MANAGER({api, method, payload, successCb, errorCb, commit})
	},
	// 获取VISA下载地址
	getVisaDownLoadUrl({commit}) {
		let api = API_MAP.VISA_INVITATION;
		let method = 'get';
		let successCb = (data) => {
			commit('setVISAUrl', data.url || '');
		};
		let errorCb = () => {

		};
		API_MANAGER({api, method, successCb, errorCb, commit});
	}
};

const mutations = {
	// 更新请求状态
	setHasData(state, status) {
		state.hasData = status;
	},
	// 设置协议信息
	setProtocol(state, data) {
		state.protocolObj = data;
	},
	// 设置VISA下载地址
	setVISAUrl(state, url) {
		state.VISA_URL = url;
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
